import Vue from 'vue'

export const getBidCards = () => Vue.axios.get('bidCards')
export const getUnModeratedBidCards = params => Vue.axios.get('bidCards/unModerated', { params })

export const getBidCard = id => Vue.axios.get(`bidCards/${id}`)
export const createBidCard = () => Vue.axios.post('bidCards')
export const updateBidCard = (id, data) => Vue.axios.put(`bidCards/${id}`, data)
export const resetBidCard = id => Vue.axios.put(`bidCards/${id}/reset`)
export const moderateBidCard = id => Vue.axios.put(`bidCards/${id}/moderated`)



// WEBPACK FOOTER //
// ./src/services/bid-cards.js